import { Card } from '@zorro/design-system/v2/Card';
import { Checkbox } from '@zorro/design-system/v2/Checkbox';
import { List } from '@zorro/design-system/v2/List';
import { Box, Stack, Text } from '@zorro/web/design-system';

type Props = {
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  requiredActions: string[];
};

// Shown when an awaiting-payment plan's initial payment is being marked
// complete: the confirmation email was held back at confirmation and goes out
// with this save unless the operator opts out.
export const PaymentCompletionEmailCard = ({
  isChecked,
  onChange,
  requiredActions,
}: Props) => (
  <Card variant="white-border" radius="md" p={0} style={{ overflow: 'hidden' }}>
    <Stack gap="md">
      <Box
        style={{
          borderBottom: '1px solid var(--color-border-default-primary)',
        }}
      >
        <Checkbox
          checked={isChecked}
          pl="xl"
          pr="md"
          py="sm"
          label={
            <Text fw={600} size="sm">
              Send the confirmation email to the employee
            </Text>
          }
          onChange={(event) => onChange(event.currentTarget.checked)}
        />
      </Box>
      <Box px="xl" pb="md">
        <Stack gap="xxs">
          <Text size="sm">
            The confirmation email wasn&rsquo;t sent when this enrollment was
            confirmed because the initial payment wasn&rsquo;t complete. Marking
            the payment complete will send it now. Uncheck to skip.
          </Text>
          {requiredActions.length > 0 && (
            <>
              <Text size="sm">
                This email will contain the following actions needed:
              </Text>
              <List type="ordered" size="sm">
                {requiredActions.map((action) => (
                  <List.Item pl="xxs" key={action}>
                    {action}
                  </List.Item>
                ))}
              </List>
            </>
          )}
        </Stack>
      </Box>
    </Stack>
  </Card>
);
